<div class="center">
  <div class="login">
    <h3 class="text1">Email Has Been Reset</h3>
    <p class="text2">Your email address has been successfully updated.</p>

    <a (click)="resetEmail()" class="btn btn-primary full-width">Back to Login</a>
  </div>
</div>
